/* unplugin-vue-components disabled */import script from "./message-tip.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-tip.vue?vue&type=script&lang=ts&setup=true"

import "./message-tip.vue?vue&type=style&index=0&id=7051873f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7051873f"]])

export default __exports__